module.exports = __webpack_public_path__ + "img/zhxy_image_7.637ef124.png";